let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aZgVL")).then(() => parcelRequire('JpnY2'));